// Test IDs for the marketplace (landing, catalog, product, cart, dashboards).

export const NAV = {
  logo: 'nav-logo',
  searchInput: 'nav-search-input',
  searchBtn: 'nav-search-btn',
  cartBtn: 'nav-cart-btn',
  loginBtn: 'nav-login-btn',
  registerBtn: 'nav-register-btn',
  userMenu: 'nav-user-menu',
  logoutBtn: 'nav-logout-btn',
  dashboardLink: 'nav-dashboard-link',
  notifBtn: 'nav-notif-btn',
};

export const LANDING = {
  heroCta: 'landing-hero-cta',
  heroSell: 'landing-hero-sell',
  categoryCard: 'landing-category-card',
  featuredGrid: 'landing-featured-grid',
};

export const AUTH = {
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  nameInput: 'auth-name-input',
  phoneInput: 'auth-phone-input',
  cityInput: 'auth-city-input',
  roleBuyer: 'auth-role-buyer',
  roleSeller: 'auth-role-seller',
  submitBtn: 'auth-submit-btn',
  googleBtn: 'auth-google-btn',
  switchLink: 'auth-switch-link',
};

export const CATALOG = {
  filterCategory: 'catalog-filter-category',
  filterBrand: 'catalog-filter-brand',
  filterMinPrice: 'catalog-filter-min-price',
  filterMaxPrice: 'catalog-filter-max-price',
  applyFiltersBtn: 'catalog-apply-filters',
  productCard: (id) => `product-card-${id}`,
  productLink: (id) => `product-link-${id}`,
};

export const PRODUCT = {
  gallery: 'product-gallery',
  galleryThumb: (i) => `product-gallery-thumb-${i}`,
  price: 'product-price',
  addToCartBtn: 'product-add-to-cart',
  buyNowBtn: 'product-buy-now',
  qtyInput: 'product-qty-input',
};

export const CART = {
  itemRow: (id) => `cart-item-${id}`,
  removeBtn: (id) => `cart-remove-${id}`,
  qtyInput: (id) => `cart-qty-${id}`,
  subtotal: 'cart-subtotal',
  checkoutBtn: 'cart-checkout-btn',
};

export const CHECKOUT = {
  addressInput: 'checkout-address-input',
  cityInput: 'checkout-city-input',
  phoneInput: 'checkout-phone-input',
  payBtn: 'checkout-pay-btn',
  legalDisclaimer: 'checkout-legal-disclaimer',
  legalTermsLink: 'checkout-legal-terms-link',
  legalPoliciesLink: 'checkout-legal-policies-link',
  legalAcceptCheckbox: 'checkout-legal-accept-checkbox',
};

export const SELLER = {
  kpiSales: 'seller-kpi-sales',
  kpiOrders: 'seller-kpi-orders',
  kpiCommission: 'seller-kpi-commission',
  kpiNet: 'seller-kpi-net',
  kpiProducts: 'seller-kpi-products',
  newProductBtn: 'seller-new-product-btn',
  bulkUploadBtn: 'seller-bulk-upload-btn',
  paySubscriptionBtn: 'seller-pay-subscription-btn',
  productNameInput: 'seller-product-name',
  productCategory: 'seller-product-category',
  productBrand: 'seller-product-brand',
  productReference: 'seller-product-reference',
  productPrice: 'seller-product-price',
  productStock: 'seller-product-stock',
  productDescription: 'seller-product-description',
  productCompat: 'seller-product-compat',
  productImageUrl: 'seller-product-image-url',
  productSaveBtn: 'seller-product-save-btn',
  productDeleteBtn: (id) => `seller-product-delete-${id}`,
  shipBtn: (id) => `seller-ship-btn-${id}`,
  deliverBtn: (id) => `seller-deliver-btn-${id}`,
  onboardingBusinessName: 'onboarding-business-name',
  onboardingNit: 'onboarding-nit',
  onboardingAddress: 'onboarding-address',
  onboardingDocuments: 'onboarding-documents',
  onboardingSubmit: 'onboarding-submit-btn',
};

export const ADMIN = {
  kpiBuyers: 'admin-kpi-buyers',
  kpiSellers: 'admin-kpi-sellers',
  kpiProducts: 'admin-kpi-products',
  kpiOrders: 'admin-kpi-orders',
  kpiSales: 'admin-kpi-sales',
  kpiCommission: 'admin-kpi-commission',
  kpiSubscriptionIncome: 'admin-kpi-subscription-income',
  approveSellerBtn: (id) => `admin-approve-seller-${id}`,
  rejectSellerBtn: (id) => `admin-reject-seller-${id}`,
  disableUserBtn: (id) => `admin-disable-user-${id}`,
  activateUserBtn: (id) => `admin-activate-user-${id}`,
  commissionInput: 'admin-commission-input',
  subscriptionInput: 'admin-subscription-input',
  saveSettingsBtn: 'admin-save-settings-btn',
};

export const BUYER = {
  orderRow: (id) => `buyer-order-${id}`,
  reviewBtn: (id) => `buyer-review-btn-${id}`,
};
